"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = void 0;
const react_1 = require("react");
const locales_1 = require("../lib/locales");
/**
 * Stores locale when needed on a page
 */
function useLocale(defaultLocale) {
    const [locale, setLocale] = (0, react_1.useState)(() => (0, locales_1.getLocale)(defaultLocale));
    (0, react_1.useEffect)(() => {
        if (defaultLocale) {
            setLocale((0, locales_1.getLocale)(defaultLocale));
        }
    }, [defaultLocale]);
    const changeLocale = (0, react_1.useCallback)((newLocale) => {
        setLocale((0, locales_1.getLocale)(newLocale));
    }, [setLocale]);
    return { locale, changeLocale };
}
exports.useLocale = useLocale;
//# sourceMappingURL=useLocale.js.map